import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=50a1b23f&scoped=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"
import style0 from "./Help.vue?vue&type=style&index=0&id=50a1b23f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1b23f",
  null
  
)

export default component.exports